import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { switchMap } from 'rxjs/operators';

import { CodeTableItem } from 'app/core/code-table-item';
import { ConfigService } from 'app/core/config.service';


@Injectable()
export class CodeTableService {

  constructor(private http: HttpClient, private configService: ConfigService) { }

  getBoardMeetingTypes(): Observable<CodeTableItem[]> {
    return this.configService.getConfigAsync().pipe(
      switchMap(config => 
        this.http.get<CodeTableItem[]>(config.portalApiEndpoint + `boardmeetingtype`)
      )
    );
  }

  getPublicProcurementClasses(onlyActive: boolean): Observable<CodeTableItem[]> {
    const params = new HttpParams().set('onlyActive', JSON.stringify(onlyActive));
    return this.configService.getConfigAsync().pipe(
      switchMap(config => 
        this.http.get<CodeTableItem[]>(config.portalApiEndpoint + `publicprocurementclass`, { params })
      )
    );
  }

  getPublicProcurementSubClasses(onlyActive: boolean): Observable<CodeTableItem[]> {
    const params = new HttpParams().set('onlyActive', JSON.stringify(onlyActive));
    return this.configService.getConfigAsync().pipe(
      switchMap(config => 
        this.http.get<CodeTableItem[]>(config.portalApiEndpoint + `publicprocurementsubclass`, { params })
      )
    );
  }

  getPublicProcurementAllocationMethods(onlyActive: boolean): Observable<CodeTableItem[]> {
    const params = new HttpParams().set('onlyActive', JSON.stringify(onlyActive));
    return this.configService.getConfigAsync().pipe(
      switchMap(config => 
        this.http.get<CodeTableItem[]>(config.portalApiEndpoint + `publicprocurementallocationmethod`, { params })
      )
    );
  }
}
